module.exports = __webpack_public_path__ + "static/media/dark-logo.c8548d29.png";